import Client from './Client'

export interface IDocument {
  id: string
  [fieldName: string]: any
}

interface IDocumentList {
  total: number
  items: IDocument[]
}

export interface IQuery {
  from?: number
  limit?: number
  calc_total?: number // 0 | 1
  filter?: string[] // fieldName:value
  order?: string[] // fieldName+ | fieldName-
}

const API_PREFIX = '/sc/db/api/v2/pg'

/**
 * Класс для работы с апи v1.0.1
 */
export default class PG {
  constructor(public readonly client: Client) {}

  getDocumentList(
    dbName: string,
    dbSchema: string,
    dbCollection: string,
    dbQueryParams: IQuery
  ): Promise<IDocumentList> {
    return this.client.app
      .createAuthenticatedRequest(
        `${API_PREFIX}/${dbName}/${dbSchema}/${dbCollection}`
      )
      .setQueryParams(dbQueryParams)
      .execute()
  }

  getDocumentById(
    dbName: string,
    dbSchema: string,
    dbCollection: string,
    id: string
  ): Promise<IDocument> {
    return this.client.app
      .createAuthenticatedRequest(
        `${API_PREFIX}/${dbName}/${dbSchema}/${dbCollection}/${id}`
      )
      .execute()
  }

  insertDocument(
    dbName: string,
    dbSchema: string,
    dbCollection: string,
    document: IDocument
  ): Promise<IDocument> {
    return this.client.app
      .createAuthenticatedRequest(
        `${API_PREFIX}/${dbName}/${dbSchema}/${dbCollection}`
      )
      .postJson(document)
      .execute()
  }

  updateDocument(
    dbName: string,
    dbSchema: string,
    dbCollection: string,
    id: string,
    document: IDocument
  ): Promise<IDocument> {
    return this.client.app
      .createAuthenticatedRequest(
        `${API_PREFIX}/${dbName}/${dbSchema}/${dbCollection}/${id}`
      )
      .putJson(document)
      .execute()
  }

  deleteDocument(
    dbName: string,
    dbSchema: string,
    dbCollection: string,
    id: string
  ): Promise<void> {
    return this.client.app
      .createAuthenticatedRequest(
        `${API_PREFIX}/${dbName}/${dbSchema}/${dbCollection}/${id}`
      )
      .delete()
      .execute()
  }
}
